var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnBoth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#f6f5f5;}.cls-4{fill:#f35059;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{clip-path:url(#clip-path-4);}.cls-8{fill:#fff1f1;}.cls-9{fill:#4c589b;}.cls-10{clip-path:url(#clip-path-5);}.cls-11{clip-path:url(#clip-path-6);}.cls-12{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -519.89,
    y: 0.44,
    width: 500,
    height: 500,
    rx: 115
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1,
    y: 1,
    width: 500,
    height: 500,
    rx: 115
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.63,466.5,466,34a114.63,114.63,0,0,1,34,81.44v270c0,63.25-51.75,115-115,115H115A114.62,114.62,0,0,1,33.63,466.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.31,
    y: 0.75,
    width: 500,
    height: 500,
    rx: 115
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.83,34.38,34.47,466.88a114.63,114.63,0,0,1-34-81.44v-270c0-63.25,51.75-115,115-115h270A114.62,114.62,0,0,1,466.83,34.38Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.46,
    y: 0.28,
    width: 500,
    height: 500,
    rx: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "en_uk"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -315.9,
    y: -82,
    width: 82.67,
    height: 661.5,
    transform: "matrix(0.54, -0.84, 0.84, 0.54, -333.65, -117)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -315.9,
    y: -76,
    width: 82.67,
    height: 661.5,
    transform: "translate(-637.76 163.22) rotate(-123)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -143.55,
    y: 157.92,
    width: 23.69,
    height: 342.42,
    transform: "translate(-336 39.41) rotate(-57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -139.5,
    y: -20.83,
    width: 23.69,
    height: 342.42,
    transform: "translate(-323.3 125.22) rotate(-123)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "en_both"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.31,
    y: 0.75,
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0.31,
    y: 0.75,
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 204.29,
    y: -81.69,
    width: 82.67,
    height: 661.5,
    transform: "matrix(0.54, -0.84, 0.84, 0.54, -97.03, 319.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 204.29,
    y: -75.69,
    width: 82.67,
    height: 661.5,
    transform: "translate(165.49 599.98) rotate(-123)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 97.72,
    y: 184.49,
    width: 23.69,
    height: 342.42,
    transform: "translate(-129.07 641.31) rotate(-123)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 376.65,
    y: 158.23,
    width: 23.69,
    height: 342.42,
    transform: "translate(-99.39 475.83) rotate(-57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.55,
    y: 5,
    width: 23.69,
    height: 342.42,
    transform: "translate(-94.78 177.85) rotate(-57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 380.69,
    y: -20.52,
    width: 23.69,
    height: 342.42,
    transform: "translate(479.95 561.98) rotate(-123)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -2.69,
    y: 187.72,
    width: 509.37,
    height: 127.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -2.69,
    y: 187.72,
    width: 509.37,
    height: 127.41,
    transform: "translate(0.57 503.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.31,
    y: 210.83,
    width: 500.89,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.31,
    y: 210.83,
    width: 500.89,
    height: 80,
    transform: "translate(-0.08 501.58) rotate(-90)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.46,
    y: 0.28,
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.66,
    y: 461.82,
    width: 512.24,
    height: 38.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.54,
    y: 380.6,
    width: 512.24,
    height: 38.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.54,
    y: 304.6,
    width: 512.24,
    height: 38.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.54,
    y: 226.6,
    width: 512.24,
    height: 38.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.54,
    y: 153.6,
    width: 512.24,
    height: 38.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.54,
    y: 78.6,
    width: 512.24,
    height: 38.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.54,
    y: 1.6,
    width: 512.24,
    height: 38.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0.46,
    y: 0.28,
    width: 265,
    height: 265
  }), /*#__PURE__*/React.createElement("g", {
    id: "stars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M230.32,253.8l2.58-7.94L237.07,233l6.75,20.8-17.7-12.87H248"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.64,253.8l2.58-7.94L185.39,233l6.75,20.8-17.69-12.87h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M125.8,253.58l2.58-7.94,4.38-12.2,6.75,20.79-17.9-13.51H143.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M73.58,253.58l2.58-7.94,4.38-12.2,6.75,20.79L69.38,240.72h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.36,253.58l2.58-7.94,4.38-12.2,6.75,20.79L17.16,240.72h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M230.32,200.75l2.58-7.94L237.07,180l6.75,20.8-17.7-12.86H248"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.64,200.75l2.58-7.94L185.39,180l6.75,20.8-17.69-12.86h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M125.8,200.54l2.58-7.94,4.38-12.21,6.75,20.8-17.9-13.52H143.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M73.58,200.54l2.58-7.94,4.38-12.21,6.75,20.8L69.38,187.67h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.36,200.54l2.58-7.94,4.38-12.21,6.75,20.8L17.16,187.67h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M230.32,146.44l2.58-7.94,4.17-12.86,6.75,20.8-17.7-12.86H248"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.64,146.44l2.58-7.94,4.17-12.86,6.75,20.8-17.69-12.86h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M125.8,146.23l2.58-7.94,4.38-12.21,6.75,20.8-17.9-13.51H143.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M73.58,146.23l2.58-7.94,4.38-12.21,6.75,20.8L69.38,133.37h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.36,146.23l2.58-7.94,4.38-12.21,6.75,20.8L17.16,133.37h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M230.32,86.91,232.9,79l4.17-12.86,6.75,20.8-17.7-12.86H248"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.64,86.91,181.22,79l4.17-12.86,6.75,20.8L174.45,74.05h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M125.8,86.7l2.58-7.94,4.38-12.21,6.75,20.8-17.9-13.52H143.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M73.58,86.7l2.58-7.94,4.38-12.21,6.75,20.8L69.38,73.83h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.36,86.7l2.58-7.94,4.38-12.21,6.75,20.8L17.16,73.83h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M230.32,32.08l2.58-7.94,4.17-12.86,6.75,20.8-17.7-12.87H248"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.64,32.08l2.58-7.94,4.17-12.86,6.75,20.8L174.45,19.21h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M125.8,31.86l2.58-7.94,4.38-12.2,6.75,20.79L121.61,19H143.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M73.58,31.86l2.58-7.94,4.38-12.2,6.75,20.79L69.38,19h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.36,31.86l2.58-7.94,4.38-12.2,6.75,20.79L17.16,19h21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M47.59,173.78l2.57-7.94L54.34,153l6.75,20.8-17.7-12.87H65.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M99.61,173.78l2.58-7.94L106.36,153l6.76,20.8-17.7-12.87h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M152.69,173.78l2.57-7.94L159.44,153l6.75,20.8-17.7-12.87h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.13,173.78l2.57-7.94L209.88,153l6.75,20.8-17.7-12.87h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M47.59,227.6l2.57-7.94,4.18-12.86,6.75,20.8-17.7-12.86H65.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M99.61,227.6l2.58-7.94,4.17-12.86,6.76,20.8-17.7-12.86h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M152.69,227.6l2.57-7.94,4.18-12.86,6.75,20.8-17.7-12.86h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.13,227.6l2.57-7.94,4.18-12.86,6.75,20.8-17.7-12.86h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M47.59,116.89,50.16,109l4.18-12.86,6.75,20.8L43.39,104H65.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M99.61,116.89l2.58-7.94,4.17-12.86,6.76,20.8L95.42,104h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M152.69,116.89l2.57-7.94,4.18-12.86,6.75,20.8L148.49,104h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.13,116.89,205.7,109l4.18-12.86,6.75,20.8L198.93,104h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M47.59,57.88l2.57-7.94,4.18-12.86,6.75,20.8L43.39,45H65.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M99.61,57.88l2.58-7.94,4.17-12.86,6.76,20.8L95.42,45h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M152.69,57.88l2.57-7.94,4.18-12.86,6.75,20.8L148.49,45h21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.13,57.88l2.57-7.94,4.18-12.86,6.75,20.8L198.93,45h21.89"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 221.2,
    y: -92,
    width: 63.31,
    height: 684,
    transform: "translate(254.88 605.58) rotate(-135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnBoth);
export default __webpack_public_path__ + "static/media/en_both.a19705eb07e5b0372a7a7ea9938e7be7.svg";
export { ForwardRef as ReactComponent };